import { render } from "./GameTemplate.vue?vue&type=template&id=405a64c6&scoped=true"
import script from "./GameTemplate.vue?vue&type=script&lang=js"
export * from "./GameTemplate.vue?vue&type=script&lang=js"

import "./GameTemplate.vue?vue&type=style&index=0&id=405a64c6&scoped=true&lang=css"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405a64c6"]])

export default __exports__